import React, { useState } from 'react';
import Slide from './SlideRiver';
import slides from './SlidesRiver';
import './River5India.css';


const River5India = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    if (currentSlide < slides.length - 1) {
      cancelSpeech();
      setCurrentSlide(currentSlide + 1);
      readText(slides[currentSlide + 1].text);
    }
  };

  const readText = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(utterance);
  };

  const cancelSpeech = () => {
    window.speechSynthesis.cancel();
  };

  return (
    <div className="AppSBB">
      <h1>Top 5 Rivers in India</h1>
      <Slide 
        image={slides[currentSlide].image} 
        text={slides[currentSlide].text} 
        readText={readText} 
      />
      <button onClick={nextSlide} className="next-button">
        Next
      </button>
    </div>
  );
};

export default River5India;